import { render, staticRenderFns } from "./list_approve.vue?vue&type=template&id=c0d70826&scoped=true"
import script from "./list_approve.vue?vue&type=script&lang=js"
export * from "./list_approve.vue?vue&type=script&lang=js"
import style0 from "./list_approve.vue?vue&type=style&index=0&id=c0d70826&prod&lang=css&scoped=true"
import style1 from "./list_approve.vue?vue&type=style&index=1&id=c0d70826&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d70826",
  null
  
)

export default component.exports